import { render } from "./persistentvolumeclaim.vue?vue&type=template&id=4fcd723e&scoped=true"
import script from "./persistentvolumeclaim.vue?vue&type=script&lang=js"
export * from "./persistentvolumeclaim.vue?vue&type=script&lang=js"

import "./persistentvolumeclaim.vue?vue&type=style&index=0&id=4fcd723e&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcd723e"]])

export default __exports__